import React from 'react';
import '../../../styles/components/pricing-card.scss';
import BaseText from '../typography/BaseText';
import InternalLinkButton from '../buttons/InternalLinkButton';
import AccountingModal from '../../common/AccountingModal';
import PrimaryButton from '../buttons/PrimaryButton';

const PricingCard = ({
  title,
  price,
  currency,
  info,
  heading,
  items,
  weRecommend,
  information,
  bgColor,
  currencyRate,
  isAccountingPage,
  acccountingModal,
  buttonText,
  path
}) => {
  return (
    <div className={`w-full rounded ${weRecommend ? 'mt-2' : 'mt-8'} ${bgColor}`}>
      {weRecommend && (
        <div className="bg-blue-500 rounded-t flex justify-center w-full">
          <BaseText
            textAlign="text-center"
            className="p-1"
            textColor="text-white"
            title="WE RECOMMEND"
            fontSize="12px"
          />
        </div>
      )}
      <div className="max-w-md mx-auto shadow-md p-6 w-full">
        <div className="flex flex-col justify-center items-center">
          <BaseText fontWeight="text-extra-bold" textColor="text-gray-300" fontSize="32px" title={title} />

          <div className="text-center flex">
            <BaseText fontWeight="text-extra-bold" fontSize="56px" textColor="text-blue-500" title={price} />
            <span className="text-xl text-extra-bold text-blue-500 mt-10 font-bold">{currency}</span>
          </div>
          <BaseText fontWeight="text-regular" fontSize="21px" textColor="text-blue-500" title={currencyRate} />

          <BaseText fontSize="12px" title={info} textAlign="text-center" className="mb-4" />
          {acccountingModal ? (
            <AccountingModal price={price}>
              <PrimaryButton caption={buttonText} className="my-6" boxShadow="0 9px 32px 0 rgba(0,0,0,.2)" />
            </AccountingModal>
          ) : (
            <InternalLinkButton
              caption={buttonText}
              path={path}
              className="my-6"
              boxShadow="0 9px 32px 0 rgba(0,0,0,.2)"
            />
          )}
        </div>

        <ul className="checklist list-none">
          {items?.map((item, index) => (
            <div key={index} className="mt-6">
              {item.headingTopText && <BaseText fontSize="14px" title={item.headingTopText} />}
              <BaseText
                fontSize="18px"
                textColor="text-gray-300"
                title={item?.heading}
                fontWeight="text-medium"
                className={!item.headingBottomText && 'mb-4'}
              />
              {item.headingBottomText && <BaseText fontSize="12px" className={'mb-4'} title={item.headingBottomText} />}
              {item.points.map((pointsdata, index) => (
                <li key={index} className="checklist-item text-13ct flex">
                  {pointsdata}
                </li>
              ))}
            </div>
          ))}
        </ul>
        <BaseText fontSize="12px" title={information} textAlign="text-left" className="mt-6 mb-16" />
      </div>
    </div>
  );
};

export default PricingCard;
